import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect, Link, withRouter} from 'react-router-dom'
import {FiEye, FiEyeOff} from 'react-icons/fi'

import './index.css'

class RegisterForm extends Component {
  state = {
    username: '',
    password: '',
    confirmPassword: '',
    showSubmitError: false,
    errorMsg: '',
    isLoading: false,
    showPassword: false,
    showConfirmPassword: false,
  }

  onChangeUsername = event => {
    this.setState({username: event.target.value})
  }

  onChangePassword = event => {
    this.setState({password: event.target.value})
  }

  onChangeConfirmPassword = event => {
    this.setState({confirmPassword: event.target.value})
  }

  onSubmitSuccess = jwtToken => {
    const {history} = this.props
    Cookies.set('jwt_token', jwtToken, {
      expires: 30,
    })
    history.replace('/')
  }

  onSubmitFailure = errorMsg => {
    this.setState({showSubmitError: true, errorMsg, isLoading: false})
  }

  submitForm = async event => {
    event.preventDefault()
    const {username, password, confirmPassword} = this.state

    if (password !== confirmPassword) {
      this.onSubmitFailure("Passwords don't match")
      return
    }

    this.setState({isLoading: true, showSubmitError: false, errorMsg: ''})

    const userDetails = {username, password}
    const url = `${process.env.REACT_APP_API_BASE_URL}/register`
    const options = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(userDetails),
    }

    try {
      const response = await fetch(url, options)
      const data = await response.json()
      if (response.ok === true) {
        this.onSubmitSuccess(data.jwt_token)
      } else {
        this.onSubmitFailure(data.error_msg)
      }
    } catch (error) {
      this.onSubmitFailure('Network error. Please try again.')
    }
  }

  renderUsernameField = () => {
    const {username} = this.state

    return (
      <>
        <label className="input-label" htmlFor="username">
          USERNAME
        </label>
        <input
          type="text"
          id="username"
          className="username-input-field"
          value={username}
          onChange={this.onChangeUsername}
          placeholder="Username"
          required
        />
      </>
    )
  }

  toggleShowPassword = () => {
    this.setState(prevState => ({showPassword: !prevState.showPassword}))
  }

  toggleShowConfirmPassword = () => {
    this.setState(prevState => ({showConfirmPassword: !prevState.showConfirmPassword}))
  }

  renderPasswordField = () => {
    const {password, showPassword} = this.state

    return (
      <>
        <label className="input-label" htmlFor="password">
          PASSWORD
        </label>
        <div className="password-input-wrapper">
          <input
            type={showPassword ? 'text' : 'password'}
            id="password"
            className="password-input-field"
            value={password}
            onChange={this.onChangePassword}
            placeholder="Password"
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="show-password-button"
            onClick={this.toggleShowPassword}
            aria-label="Toggle password visibility"
          >
            {showPassword ? <FiEyeOff className="password-icon" /> : <FiEye className="password-icon" />}
          </button>
        </div>
      </>
    )
  }

  renderConfirmPasswordField = () => {
    const {confirmPassword, showConfirmPassword} = this.state

    return (
      <>
        <label className="input-label" htmlFor="confirmPassword">
          CONFIRM PASSWORD
        </label>
        <div className="password-input-wrapper">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            id="confirmPassword"
            className="password-input-field"
            value={confirmPassword}
            onChange={this.onChangeConfirmPassword}
            placeholder="Confirm Password"
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="show-password-button"
            onClick={this.toggleShowConfirmPassword}
            aria-label="Toggle confirm password visibility"
          >
            {showConfirmPassword ? <FiEyeOff className="password-icon" /> : <FiEye className="password-icon" />}
          </button>
        </div>
      </>
    )
  }

  render() {
    const {showSubmitError, errorMsg, isLoading} = this.state
    const jwtToken = Cookies.get('jwt_token')

    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }

    return (
      <div className="register-form-container">
        <img
          src="https://assets.ccbp.in/frontend/react-js/nxt-trendz-logo-img.png"
          className="register-website-logo-mobile-img"
          alt="website logo"
        />
        <img
          src="https://assets.ccbp.in/frontend/react-js/nxt-trendz-login-img.png"
          className="register-img"
          alt="website login"
        />
        <form className="form-container" onSubmit={this.submitForm}>
          <img
            src="https://assets.ccbp.in/frontend/react-js/nxt-trendz-logo-img.png"
            className="register-website-logo-desktop-img"
            alt="website logo"
          />
          <div className="input-container">{this.renderUsernameField()}</div>
          <div className="input-container">{this.renderPasswordField()}</div>
          <div className="input-container">
            {this.renderConfirmPasswordField()}
          </div>
          <button
            type="submit"
            className="register-button"
            disabled={isLoading}
          >
            {isLoading ? 'Creating Account...' : 'Register'}
          </button>
          {showSubmitError && <p className="error-message">*{errorMsg}</p>}
          <p className="login-link-text">
            Already have an account?{' '}
            <Link to="/login" className="login-link">
              Login here
            </Link>
          </p>
        </form>
      </div>
    )
  }
}

export default withRouter(RegisterForm)
